/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './registerPush.defs'
export { main as default } from './registerPush.defs'
